'use strict';

var styled = require('styled-components');
var component = require('../../Icon/component.js');
require('react');
require('../../Tooltip/component.js');
var cell = require('./cell.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const CellIconStyled = styled__default.default(cell.Cell) `
  padding-right: 0.5rem;

  & > span {
    display: flex;
    overflow: initial;
    justify-content: center;
  }
`;
const IconCell = styled__default.default(component.Icon) `
  ${({ onMouseDown }) => (onMouseDown ? 'cursor: pointer;' : null)}
`;

exports.CellIconStyled = CellIconStyled;
exports.IconCell = IconCell;
//# sourceMappingURL=cellIcon.styles.js.map
